import React, { useState } from 'react';

import TpDialog from '../shared/tp_dialog';
import { FIELD_ERROR_TEXT, remove_impact_text } from './adapters';
import { validate_reason } from './form_logic';
import { LIMITS } from './params';

/* remove (or, for the SYSTEM carry-forward, waive) an entry. */
const RemoveModal = ({ row, saving, error_text, on_submit, on_close, on_focus_lost }) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const waive = row.is_system;

  const submit = () => {
    const check = validate_reason(reason);
    if (!check.ok) {
      setError(check.code);
      return;
    }
    on_submit(row, check.reason);
  };

  return (
    <TpDialog
      title_id="tp-ap-remove-title"
      title={waive ? 'Waive the carry-forward' : 'Remove this entry'}
      size="sm"
      busy={saving}
      on_close={on_close}
      on_focus_lost={on_focus_lost}
    >
      <div className="tp-modal">
        <div className="tp-ctx">
          <b>{row.teacher_name}</b> · {row.month_text} · {row.category_label} · {row.amount_text}
          {row.note ? <div>Note: {row.note}</div> : null}
        </div>
        <div className="tp-banner tp-banner-warn">{remove_impact_text(row)}</div>
        <div className="tp-field">
          <label htmlFor="tp-ap-remove-reason">
            {waive
              ? 'Reason for waiving (internal, required)'
              : 'Reason for removal (internal, required)'}
          </label>
          <textarea
            id="tp-ap-remove-reason"
            className="tp-textarea"
            rows={3}
            maxLength={LIMITS.REASON_MAX_LEN}
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              setError('');
            }}
            placeholder={
              waive ? 'Why this deficit is not being recovered' : 'Why this entry is being removed'
            }
          />
          {error ? <span className="tp-err">{FIELD_ERROR_TEXT[error]}</span> : null}
        </div>
        {/* a refusal raised while this modal is open renders here, not under the overlay. */}
        {error_text ? (
          <div className="tp-banner tp-banner-error" role="alert">
            {error_text}
          </div>
        ) : null}
        <div className="tp-modal-ft">
          {/* aria-disabled, not disabled: disabling the focused button drops focus. */}
          <button
            type="button"
            className="tp-btn-ghost"
            onClick={saving ? undefined : on_close}
            aria-disabled={saving ? 'true' : undefined}
          >
            Cancel
          </button>
          <button
            type="button"
            className="tp-btn tp-btn-danger"
            onClick={saving ? undefined : submit}
            aria-disabled={saving ? 'true' : undefined}
          >
            {saving ? 'Saving…' : waive ? 'Waive carry-forward' : 'Remove entry'}
          </button>
        </div>
      </div>
    </TpDialog>
  );
};

export default RemoveModal;
